<template>
  <div class="bg-primary-bg dark:bg-gray-800 p-6 rounded-xl shadow">
    <h2 class="text-lg font-semibold text-gray-800 dark:text-white mb-4">Günlük Teslimat Miktarı</h2>
    <Line :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { getApi } from '@/services/api'
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler
)

export default {
  name: 'OrderChart',
  components: { Line },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Teslimat Sayısı',
            data: [],
            borderColor: '#6366f1',
            backgroundColor: '#6366f1',
            tension: 0.3,
            fill: false,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        plugins: { legend: { display: false }, tooltip: { enabled: true } },
        scales: {
          y: { beginAtZero: true, ticks: { stepSize: 1 } },
        },
      },
    }
  },
  async mounted() {
    await this.fetchWeeklyStats();
  },
  methods: {
    getWeekStartAndEnd() {
      const now = new Date();
      const day = now.getDay();
      const diffToMonday = day === 0 ? -6 : 1 - day;
      const weekStart = new Date(now);
      weekStart.setDate(now.getDate() + diffToMonday);
      weekStart.setHours(0, 0, 0, 0);
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 6);
      weekEnd.setHours(23, 59, 59, 999);
      return { weekStart, weekEnd };
    },
    async fetchWeeklyStats() {
      const { weekStart, weekEnd } = this.getWeekStartAndEnd();
      const params = new URLSearchParams({
        start: weekStart.toISOString(),
        end: weekEnd.toISOString()
      });
      const res = await getApi(`/deliveries/weekly-stats?${params.toString()}`);
      this.chartData.labels = res.labels;
      this.chartData.datasets[0].data = res.counts;
      this.chartData = JSON.parse(JSON.stringify(this.chartData));
    }
  }
}
</script>
